'use client';

import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { CollapsibleInterlinking } from '@page-builder/Components/InterLinking/CollapsibleInterLinking/CollapsibleInterlinking';

import { transformToInterlinkingContent } from './Utils/transformToInterlinkingContent';
import type {
  ExtendedAggregations,
  VehicleInterlinkingClientProps,
} from './VehicleInterlinking.entities';

import styles from './VehicleInterlinking.module.css';

export const VehicleInterlinkingClient = ({
  combinedParams,
  serverAggregations,
  messages,
  root,
}: VehicleInterlinkingClientProps) => {
  const atomAggregations = useAtomValue(aggregationsAtom);
  const aggregations: ExtendedAggregations =
    Object.keys(atomAggregations['body-type'] ?? {}).length > 0
      ? {
          ...atomAggregations,
          make: serverAggregations.make,
          model: serverAggregations.model,
          variant: serverAggregations.variant,
          // Ensure we have the variants array from atom aggregations
          variants: atomAggregations.variants,
        }
      : serverAggregations;
  const interlinkingContent = transformToInterlinkingContent({
    aggregations,
    serverAggregations,
    messages,
    root,
    combinedParams,
  });
  return (
    <div className={styles.container}>
      <CollapsibleInterlinking {...interlinkingContent} />
    </div>
  );
};
